
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, SaveUdfViewModel, UdfContext, UserDefinedFieldViewModel } from "@tylertech/tyler-api-types";

/**
 * UserDefinedFieldService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class UserDefinedFieldService {
    private readonly $apiService = inject(ApiService);
    
    Get(pParms: UdfContext): Promise<ExecutionResult<UserDefinedFieldViewModel[]>> {
        return this.$apiService.sendAuth("IUserDefinedFieldService/Get", pParms);
    }
    RefreshTableSchema(types: any[]): Promise<void> {
        return this.$apiService.sendAuth("IUserDefinedFieldService/RefreshTableSchema", types);
    }
    Save(pParms: SaveUdfViewModel): Promise<ExecutionResult<any>> {
        return this.$apiService.sendAuth("IUserDefinedFieldService/Save", pParms);
    }
    Verify(pParms: SaveUdfViewModel): Promise<ExecutionResult<any>> {
        return this.$apiService.sendAuth("IUserDefinedFieldService/Verify", pParms);
    }
}
